import React from "react"
import { StaticQuery, graphql } from "gatsby"

const SectionQuery = ({ id, render: Render, ...rest }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulSectionMap {
          edges {
            node {
              id
              content {
                json
              }
              contentTheme
              mapLeftDesktop
              isFullHeight
              mapCenter {
                lat
                lon
              }
              illustration {
                resize(width:800) {
                  src
                }
              }
              description {
                childMarkdownRemark {
                  html
                }
              }
            }
          }
        }
        allContentfulSectionImageWithContent {
          edges {
            node {
              id
              imageLeftDesktop
              contentTheme
              scrollAnimation
              hideImageOnMobile
              image {
                resize(width:2200) {
                  src
                }
              }
              imageMobile {
                resize(width:1000) {
                  src
                }
              }
              content { 
                __typename
                ...on ContentfulContentText {
                  id
                }
                ...on ContentfulContentWidget {
                  id
                  type
                }
                ...on ContentfulContentForm {
                  id
                }
              }
            }
          }
        }
        allContentfulSectionTeam {
          edges {
            node {
              id
              isRandom
            }
          }
        }
        allContentfulSectionJobOpenings {
          edges {
            node {
              id
              displayTitle
              button {
                text
                link
              }
            }
          }
        }
        allContentfulSectionContentCollection {
          edges {
            node {
              id
              editableContent {
                json
              }
              items {
                __typename
                ...on ContentfulContentText {
                  id
                  tags
                }
                ...on ContentfulContentLink {
                  id
                }
              }
              columns
              theme
              alignment
            }
          }
        }
        allContentfulSectionPress {
          edges {
            node {
              id
              content {
                __typename
                ...on ContentfulContentText {
                  id
                }
              }
              logos {
                resize(width:800) {
                  src
                }
              }
              button {
                link
                text
              }
            }
          }
        }
        allContentfulSectionLocations {
          edges {
            node {
              id
              editableContent {
                json
              }
              display
              theme
            }
          }
        }
        allContentfulSectionBanner {
          edges {
            node {
              id
              headlineContent {
                json
              }
              sublineContent {
                json
              }
              theme
            }
          }
        }
        allContentfulSectionGallery {
          edges {
            node {
              id
              images {
                resize(width:2500) {
                  src
                }
              }
            }
          }
        }
        allContentfulSectionExpandingGallery {
          edges {
            node {
              id
              editableContent {
                json
              }
              items {
                id
                altText
                image {
                  resize(width:800) {
                    src
                  }
                }
                mainContent {
                  json
                }
                additionalContent {
                  json
                }
              }
            }
          }
        }
        allContentfulContentForm {
          edges {
            node {
              __typename
              id
            }
          }
        }
        allContentfulContentWidget {
          edges {
            node {
              __typename
              id
              type
            }
          }
        }
        allContentfulContentText {
          edges {
            node {
              __typename
              id
            }
          }
        }
      }
    `}
    render={data => {
      const sections = [
        ...data.allContentfulSectionImageWithContent.edges,
        ...data.allContentfulSectionExpandingGallery.edges,
        ...data.allContentfulSectionGallery.edges,
        ...data.allContentfulSectionMap.edges,
        ...data.allContentfulSectionTeam.edges,
        ...data.allContentfulSectionLocations.edges,
        ...data.allContentfulSectionPress.edges,
        ...data.allContentfulSectionJobOpenings.edges,
        ...data.allContentfulSectionContentCollection.edges,
        ...data.allContentfulSectionBanner.edges,

        ...data.allContentfulContentForm.edges,
        ...data.allContentfulContentWidget.edges,
        ...data.allContentfulContentText.edges,
      ]

      if (!id) {
        console.warn('Missing id. Probably need to update PageQuery or another higher-level query.')
        return null
      }

      const section = sections.find(
        ({ node }) => node.id === id
      )

      if (!section) {
        console.warn('No section found with this id. Probably need to update SectionQuery.')
        return null
      }

      return <Render data={section.node} {...rest} />
    }}
  />
)

export default SectionQuery
